// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk ROthe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : general react component utils
// =============================================================================
// ---Third-party imports
import React, {Children} from 'react'
import {isFragment, isElement} from 'react-is'

// ---Framework imports
import {isFunction, isString} from 'ldash'
// ---Globals

// add props to children (ignore null's)
// https://reactjs.org/docs/react-api.html#reactchildren
export const applyProps = (children, props) =>
  Children.map(children, child => {
    if (child && isElement(child)) {
      if (isFragment(child)) {
        // traverse fragments recursivly
        return applyProps(child.props.children, props)
      } else {
        return React.cloneElement(child, isFunction(props) ? props(child.props) : props)
      }
    } else {
      return child
    }
  })
